import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="mx-auto mt-24 max-w-xl text-center">
      <h1 className="text-3xl font-semibold">Page not found</h1>
      <p className="mt-3 text-neutral-600 dark:text-neutral-400">
        The docs section you're looking for doesn't exist — yet.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600"
      >
        Back to home
      </Link>
    </div>
  );
}
